import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Suspense } from 'react';
import './i18n'
import Navbar from './components/Navbar'
import Landing from './components/Landing/Landing'
import WebPages from './components/Services/WebPages'
import Contact from './components/Forms/Contact'
import GetQuote from './components/Forms/GetQuote'
import Team from './components/Team/Team'
import Notfound from './components/Notfound'
import Footer from './components/Footer'
import Ecommerce from './components/Services/Ecommerce'
import Database from './components/Services/Database'
import Design from './components/Services/Design'
import Seo from './components/Services/Seo'
import Portfolio from './components/Portfolio/Portfolio'
import PortfolioDetails from './components/Portfolio/ProjectDetails'
import Faq from './components/Faqs/Faq'
import { ToastContainer } from 'react-toastify'
import TermsOfService from './PrivacyPolicy'
import PrivacyPolicy from './TermsOfService'
// import WebsiteTemplates from './components/Templates/WebsiteTemplates'
// import DatabasesTemplates from './components/Templates/DatabasesTemplates'
// import EcommerceTemplates from './components/Templates/EcommerceTemplates';

const App = () => {
  return (
    <div>
      <Suspense fallback={null}>
        <BrowserRouter>
          <Navbar/>
          <Routes>
            <Route path='/' element={<Landing/>}></Route>
            <Route path='/services/websites' element={<WebPages/>}></Route>
            <Route path='/services/ecommerce' element={<Ecommerce/>}></Route>
            <Route path='/services/databases' element={<Database/>}></Route>
            <Route path='/services/graphic-design' element={<Design/>}></Route>
            <Route path='/services/seo' element={<Seo/>}></Route>

            <Route path='/portfolio' element={<Portfolio/>}></Route>
            
            {/* <Route path='/templates/websites' element={<WebsiteTemplates/>}></Route>
            <Route path='/templates/ecommerce' element={<EcommerceTemplates/>}></Route>
            <Route path='/templates/databases' element={<DatabasesTemplates/>}></Route> */}
            
            <Route path='/portfolio/:id' element={<PortfolioDetails/>}/>

            <Route path='/team' element={<Team/>}></Route>

            <Route path='/contact' element={<Contact/>}></Route>
            <Route path='/quote' element={<GetQuote/>}></Route>

            <Route path='/terms-of-service' element={<PrivacyPolicy/>}></Route>
            <Route path='/privacy-policy' element={<TermsOfService/>}></Route>
            <Route path='*' element={<Notfound/>}></Route>
          </Routes>
          <Faq/>
          <Footer/>
        </BrowserRouter>
        
        <ToastContainer />
      </Suspense>
    </div>
  )
}

export default App;